export default "__VITE_ASSET__DVwnEqzv__"